export const API_URL = `https://click-api.mgrabowski.eu`;
